import React from "react";

import { Form, Input, Modal, message } from "antd";

import { _getSupplierPriceLists, _getSupplierPriceListSellers, _postSupplierPriceList, _putSupplierPriceList } from "../../services";
import { MKT_BASE_CURRENCY } from "../../index";
import { RemoteSelect } from "../term-contract/selects";
import { errorMessage } from "../term-contract/helpers";

const fetchSellers = async ({
    text,
}) => {
    const { data } = await _getSupplierPriceListSellers({ q: text });
    return (data.sellers || []).map(s => ({ value: s.id, label: s.status ? `${s.companyName} (${s.status})` : s.companyName }));
};

/** IST seller org search. */
export const SellerSelect = (props) => (
    <RemoteSelect placeholder="Search IST supplier" fetchOptions={fetchSellers} {...props} />
);

/**
 * Create (no `priceList`) or edit a price list header. The supplier is fixed once created; the currency is the market's.
 * A 409 on create offers to open the supplier's existing list (`onExisting`).
 */
class PriceListHeaderModal extends React.Component {

    state = {
        sellerId: this.props.priceList ? this.props.priceList.sellerId : null,
        ethSupplierId: (this.props.priceList && this.props.priceList.ethSupplierId) || "",
        notes: (this.props.priceList && this.props.priceList.notes) || "",
        saving: false
    };

    openExisting = async ({
        sellerId,
    }) => {
        const { data } = await _getSupplierPriceLists({ sellerId });
        const existing = (data.priceLists || [])[0];
        if (!existing) return;
        Modal.confirm({
            title: "This supplier already has a price list",
            content: `${existing.sellerName} already has a ${existing.currency} price list.`,
            okText: "Open it",
            onOk: () => this.props.onExisting(existing)
        });
    };

    save = async () => {
        const { priceList, onSaved } = this.props;
        const { sellerId, ethSupplierId, notes } = this.state;
        if (!sellerId) {
            message.error("Pick the supplier.");
            return;
        }
        const body = { ethSupplierId: ethSupplierId.trim() || null, notes: notes.trim() };

        this.setState({ saving: true });
        try {
            const { data } = priceList
                ? await _putSupplierPriceList({ id: priceList._id, data: body })
                : await _postSupplierPriceList({ data: { ...body, sellerId } });
            message.success(priceList ? "Price list updated" : "Price list created");
            onSaved(data.priceList);
        } catch (e) {
            this.setState({ saving: false });
            if (!priceList && e.response && e.response.status === 409) {
                this.openExisting({ sellerId }).catch(err => message.error(errorMessage({ error: err })));
                return;
            }
            message.error(errorMessage({ error: e }));
        }
    };

    render() {
        const { priceList, onCancel } = this.props;
        const { sellerId, ethSupplierId, notes, saving } = this.state;
        return (
            <Modal
                visible
                title={priceList ? `Edit ${priceList.sellerName}` : "New price list"}
                okText="Save"
                confirmLoading={saving}
                onOk={this.save}
                onCancel={onCancel}
            >
                <Form layout="vertical">
                    <Form.Item label="Supplier (IST)" required>
                        <SellerSelect
                            disabled={!!priceList}
                            value={sellerId}
                            initialOption={priceList ? { value: priceList.sellerId, label: priceList.sellerName } : null}
                            onChange={value => this.setState({ sellerId: value })}
                        />
                    </Form.Item>
                    <Form.Item label="Currency">
                        <Input disabled value={priceList ? priceList.currency : MKT_BASE_CURRENCY} />
                    </Form.Item>
                    <Form.Item label="ETH supplier ID" help="Optional. The supplier's ETH account (eezee supplier id): lines link to its products by code or model.">
                        <Input value={ethSupplierId} onChange={e => this.setState({ ethSupplierId: e.target.value })} />
                    </Form.Item>
                    <Form.Item label="Notes">
                        <Input.TextArea rows={3} value={notes} onChange={e => this.setState({ notes: e.target.value })} />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default PriceListHeaderModal;



// WEBPACK FOOTER //
// ./src/components/supplier-price-list/header-modal.js